/* @ngInject */
const myWagonPartId = () => {
  return {
    restrict: 'E',
    scope: {
      myId: '=',
      myIndex: '=',
      myLength: '=',
      myRequired: '=?',
    },
    template: require('./myWagonPartId.html'),
    /* @ngInject */
    controller: ($scope) => {

    },
    link: {
      pre: (scope, element, attrs) => { },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default myWagonPartId



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/directives/inputs/myWagonPartId.js